import type { Address, Patient } from '../../../types/ninox.types';
import type { FieldsProps } from '../../organisms/Form/Form';

export const patientFields: FieldsProps<Patient & Address> = [
  { name: 'firstname', title: 'Vorname', type: 'text' },
  { name: 'lastname', title: 'Nachname', type: 'text' },
  { name: 'birthday', title: 'Geburtsdatum', type: 'text', inputType: 'date' },
  {
    name: 'nationality',
    title: 'Nationalität',
    type: 'picker',
    items: [
      { label: 'Deutsch', value: 'german' },
      { label: 'Österreichisch', value: 'austrian' },
      { label: 'Schweizerisch', value: 'swiss' },
      { label: 'Belgisch', value: 'belgian' },
      { label: 'Britisch', value: 'british' },
      { label: 'Dänisch', value: 'danish' },
      { label: 'Finnisch', value: 'finnish' },
      { label: 'Französisch', value: 'french' },
      { label: 'Griechisch', value: 'greek' },
      { label: 'Italienisch ', value: 'italian' },
      { label: 'Niederländisch', value: 'dutch' },
      { label: 'Norwegisch', value: 'norwegian' },
      { label: 'Polnisch', value: 'polish' },
      { label: 'Portugiesisch', value: 'portuguese' },
      { label: 'Schwedisch', value: 'swedish' },
      { label: 'Spanisch', value: 'spanish' },
      { label: 'Tschechisch', value: 'czech' },
      { label: 'Türkisch', value: 'turkish' },
      { label: 'US-amerikanisch', value: 'american' },
      { label: 'Andere', value: 'other' },
    ],
  },
  {
    name: 'insurance',
    title: 'Versicherung',
    type: 'picker',
    items: [
      { label: 'privat', value: 'private' },
      { label: 'gesetzlich', value: 'statutory' },
      { label: 'keine', value: 'none' },
    ],
  },
  { name: 'street', title: 'Straße', type: 'text' },
  { name: 'houseNumber', title: 'Hausnummer', type: 'text', inputType: 'number' },
  { name: 'postcode', title: 'PLZ', type: 'text', inputType: 'number' },
  { name: 'city', title: 'Ort', type: 'text' },
  {
    name: 'country',
    title: 'Land',
    type: 'picker',
    items: [{ label: 'Deutschland', value: 'germany' }],
  },
];
